module.exports = __webpack_public_path__ + "img/2.d78830f7.png";